import { Point } from "pixi.js";
import { SymbolData } from "../../../core/reel/symbol/config/SymbolData";
import { ISymbolConfig, ISymbolDim} from "../../../core/reel/symbol/config/IReelSymbolStruct";
import { ISymbolStateData } from '../../../core/reel/symbol/config/IReelSymbolStruct';
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";


/**
 * Created by SH on 28/7/2019.
 */

 export enum ReelSymbolSize {
    ONE = 1, TWO = 2, THREE = 3,
    FOUR = 4, FIVE = 5, SIX = 6,
    SEVEN = 7, EIGHT = 8, TEN = 10,
}

export class PunkSymbolData extends SymbolData {
    
    protected static readonly _symbolArrSizes:number[] = [90,108,135,180,270,324,360,450];

    protected static readonly normalDim:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 180,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };

    public static fetchSymSize(val: number): number {
        switch (val) {
            case 7:
            case 9:
            case 11:
            case 13:
            case 18:
            case 23:
                return 360;
            case 6:
                return 324;
            case 5:
                return 270;
            case 4:
                return 180;
            case 3:
                return 135;
            case 2:
                return 108;
            case 1:
                return 90;
            default:
                return 180;
        }
    }

    public static fetchSizeStep(val: number): number {
        return [360, 324, 270, 180, 135, 108, 90][val];
    }

    public static fetchSizeTimesSize(val: number): number {
        let textureSize = this.fetchSymSize(4);
        switch (val) {
            case 7:
            case 9:
            case 11:
            case 13:
            case 18:
            case 23:
                return 360/textureSize;
            case 6:
                return 324/textureSize;
            case 5:
                return 270/textureSize;
            case 4:
                return 180/textureSize;
            case 3:
                return 135/textureSize;
            case 2:
                return 108/textureSize;
            case 1:
                return 90/textureSize;
            default:
                return 1;
        }
    }

    protected preDefinedSymbols:ISymbolConfig[] = [
        // SPECIAL
        {
            NAME: "S",
        },
        {
            NAME: "M",
            MULTI_STATES:{
                "4":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal4",
                    }
                },
                "5":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 270,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal5",
                    }
                },
                "6":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 324,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal6",
                    }
                },
                "7":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 360,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal7",
                    }
                }
            }
        },
        {
            NAME: "S1",
            MULTI_STATES:{
                "1":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"S/1/S_normal"
                    },
                    transform:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_to_W",
                    },
                    attention:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_Attention_1",
                    }
                },
                "4":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"S/4/S_normal"
                    },
                    riot:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"S/4/S_riot"
                    },
                    transform:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_to_W",
                    },
                    attention:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_AttentionWithSkull",
                    }
                  
                },
            }
        },
        {
            NAME: "W",
            MULTI_STATES: {
                "4":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "Wild_Win4",
                    },
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand4",
                    },
                    transform:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "wTransform",
                    },
                    landing:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "WildLand",
                    }
                },
                "5":{
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 90,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand4",
                    }
                },
                "7":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 360,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "Wild_Win7",
                    },
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 90,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand7",
                    }
                },
                "8":{
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 270,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand7",
                    }
                },
                "10":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "Wild_Win10",
                    },
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 270,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand7",
                    }
                }
            }
        },
        // ----------
        {
            NAME: "M1"
        },
        {
            NAME: "M2"
        },
        {
            NAME: "M3"
        },
        {
            NAME: "M4"
        },
        {
            NAME: "M5"
        },
        {
            NAME: "JW"
        },
        {
            NAME: "XWILD",
            MULTI_STATES:{
                "4":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/1/XWILD_normal"
                    },
                    spin:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/1/XWILD_spin"
                    }
                },
                "5":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/2/XWILD_normal"
                    },
                    spin:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/2/XWILD_spin"
                    }
                },
                "6":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/3/XWILD_normal"
                    },
                    spin:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/3/XWILD_spin"
                    }
                },
                "7":{
                    normal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/4/XWILD_normal"
                    },
                    spin:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH:"XWILD/4/XWILD_spin"
                    }
                },
            }
        },
        {
            NAME: "BLANK"
        }
    ];

    protected SpecialSymbols:string[] = ["S", "M", "XWILD"];

    // public static get DEFAULT_SYMBOL():ISymbolData{
    //     return PunkSymbolData._defaultConfiguration
    // }

    constructor(loader:AssetLoader, dim:ISymbolDim){
        super(loader, dim);
    }
   
    // protected static createMultiDimData(ID:number):ISymbolDim {
    //     const dim:ISymbolDim = {
    //         HEIGHT: PunkSymbolData._symbolArrSizes[ID],
    //         WIDTH: PunkSymbolData._defaultConfiguration.DIM.WIDTH,
    //         PADDING_X: PunkSymbolData._defaultConfiguration.DIM.PADDING_X,
    //         PADDING_Y: PunkSymbolData._defaultConfiguration.DIM.PADDING_Y,
    //         SCALE: PunkSymbolData._defaultConfiguration.DIM.SCALE,
    //     };
    //     return dim;
    // }
}